<template>
  <div
    :id="elId"
    class="carousel slide"
    v-touch:swipe.left="swipeLeft"
    v-touch:swipe.right="swipeRight"
  >
    <div class="carousel-inner" ref="innerContent" @click="clicked">
      <slot>
        <!-- Content will be injected here -->
      </slot>
    </div>
    <template v-if="needsControls">
      <span class="control carousel-control-prev" role="button" @click="prev">
        <span
          class="carousel-control-prev-icon my-arrow"
          aria-hidden="true"
        ></span>
        <span class="sr-only">{{ $t("common.actions.previous") }}</span>
      </span>
      <span class="control carousel-control-next" role="button" @click="next">
        <span
          class="carousel-control-next-icon my-arrow"
          aria-hidden="true"
        ></span>
        <span class="sr-only">{{ $t("common.actions.next") }}</span>
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: "Carousel",
  mounted() {
    $(this.$el).carousel({
      interval: false,
    });

    // Check whether the controls are needed
    this.$nextTick(() => {
      this.checkControls();
    });
  },
  updated() {
    this.checkControls();
  },
  computed: {
    elId: function () {
      return Math.random()
        .toString(36)
        .replace(/[^a-z]+/g, "")
        .slice(2, 10);
    },
  },
  methods: {
    checkControls: function () {
      this.needsControls = this.$refs.innerContent.children.length > 1;
    },
    next: function (event) {
      $(this.$el).carousel("next");
    },
    prev: function (event) {
      $(this.$el).carousel("prev");
    },
    clicked: function (el) {
      this.$emit("clicked");
    },
    swipeLeft: function () {
      this.next();
    },
    swipeRight: function () {
      this.prev();
    },
  },
  data() {
    return {
      needsControls: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.carousel-inner {
  height: 100%;
}

.carousel-item {
  height: 100%;
}

.control {
  opacity: 1;
}

.control:hover {
  opacity: 0.8;
}

.control {
  transition: all 0.2s ease;
  opacity: 0.5;
  background-color: rgb(61, 61, 61);
}

.my-arrow {
  opacity: 1;
}
</style>
